import { menuService } from '../../helpers/services/menu.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, ddlHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const MENU_MODULE = 'menu';

// define action 
export const GET_ALL_MENUS = 'getAllMenus';
export const GET_MENU = 'getMenu';
export const UPDATE_MENU = 'updateMenu';
export const CREATE_MENU = 'createMenu';
export const UPDATE_MENU_STATUS = 'updateMenuStatus';
export const CLONE_MENU = 'cloneMenu';
export const CLONE_ALL_MENU = 'cloneAllMenu';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_MENU_REQUEST = "getAllMenu";
const GET_MENU_REQUEST = "getMenu";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_MENUS]({ commit }, { filter }) {
        await menuService
            .getAllMenus(filter)
            .then(
                (result) => {
                    commit(GET_ALL_MENU_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_MENU]({ commit }, { id }) {
        await menuService
            .getMenu(id)
            .then(
                (result) => {
                    commit(GET_MENU_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_MENU]({ commit }, { data }) {
        commit(REQUEST)
        menuService
            .updateMenu(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.menu')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_MENU]: async ({ commit }, { redirect, data }) => {
        commit(REQUEST);
        var return_result = [];
        try {
            await menuService.createMenu(data);
            var message = i18n.t("message.createXSuccess", [i18n.t('module.menu')]);
            sharedHelper.alertSuccessMessage(message);
            commit(SUCCESS);
        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
        }

        return return_result;

    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_MENU_STATUS]({ dispatch }, { filter, data }) {
        menuService
            .updateMenuStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_MENUS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CLONE_MENU]({ dispatch, commit }, { filter, data }) {
        commit(REQUEST);
        menuService
            .clone(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.cloneMenuSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_MENUS, { filter })
                    commit(SUCCESS);
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    [CLONE_ALL_MENU]({ dispatch, commit }, { filter, data }) {
        commit(REQUEST);
        menuService
            .cloneAll(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.cloneMenuSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_MENUS, { filter })
                    commit(SUCCESS);
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    }
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Menu-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { processing: true, update: true, create: true };
    },
    [GET_ALL_MENU_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                localeName: o.locale_name,
                icon: o.icon,
                remark: o.remark,
                company: o.company,
                service: o.service,
                companyID: o.company != null ? {
                    value: o.company.uuid,
                    text: o.company.name
                } : '',
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })

    },
    [GET_MENU_REQUEST](state, data) {
        let o = data.data
        const languages = ddlHelper.getLanguages();

        var names = null;

        if (o.locale_name != null) {
            names = [];
            Object.keys(o.locale_name.name).forEach(key => {
                names.push({ language: languages.find(lang => lang.code === key), name: o.locale_name.name[key] });
            });
        }
        else {
            names = []
        }

        state.details = {
            names: names,
            uuid: o.uuid,
            name: o.name,
            icon: o.icon,
            remark: o.remark != null ? o.remark : '',
            company: o.company,
            service: o.service,
            companyID: o.company != null ? {
                value: o.company.uuid,
                text: o.company.name
            } : '',
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }
    }
}


